import { defineAsyncComponent } from 'vue'
export default {
  app: defineAsyncComponent(() => import("#build/app.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("#build/login.vue").then(m => m.default || m)),
  saas: defineAsyncComponent(() => import("#build/saas.vue").then(m => m.default || m)),
  docs: defineAsyncComponent(() => import("#build/docs.vue").then(m => m.default || m))
}